/**
 * CreatePlanningActions.js — Configuration du phidget Planning d'Actions
 * Refonte simplifiée — Design System SEIZO
 * Charte : Sofia Pro / Nunito | #002335 | #00B0FF | #F4F7F9
 *
 * Règle métier : 1 seul planning d'actions par écran (widget).
 * Si un planning existe déjà pour cet idWidget, le formulaire est grisé.
 */
import FormConfiguration, {
    BoutonSupprimerWidget,
    TitreConfigurerPhidget,
    WidgetTitre
} from "./FormConfiguration";
import React, { useState } from "react";
import { useStores } from "../../stores/Context";
import { v4 as uuidv4 } from "uuid";
import { useParams } from "react-router-dom";
import styles from "./CreatePlanningActions.module.scss";
import BtnPrimary from "../../boiteAOutils/BtnPrimary";

// Colonnes Kanban par défaut envoyées au backend lors de la création
const COLONNES_DEFAUT = [
    { titre: "À faire",   sousColonnes: [] },
    { titre: "En cours",  sousColonnes: [] },
    { titre: "Terminé",   sousColonnes: [] },
];

const CreatePlanningActions = () => {
    const [plaNom, setPlaNom] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const { ent } = useParams();
    const { widgetStore, uiStore, createWidgetStore } = useStores();

    // Vérifier si un planning d'actions existe déjà sur cet écran
    // en consultant directement la liste des widgets disponibles (pas d'appel API)
    const idWidget = createWidgetStore.idWidgetModification;
    const modeModification = idWidget && idWidget !== "";
    const planningExistant = modeModification
        ? true
        : widgetStore.widgetsAvailable.some(w => w.typeWidget === "WidgetPlanningActions");

    const peutCreer = !planningExistant && plaNom.trim() !== "" && !submitting;

    function handleCreer() {
        if (!peutCreer) return;
        setSubmitting(true);
        widgetStore.addWidgetAvailable({
            idWidget: uuidv4(),
            typeWidget: "WidgetPlanningActions",
            nomWidget: plaNom.trim(),
            disConfig: "",
            config: {
                colonnes: COLONNES_DEFAUT,
                lignes: []
            }
        });
        uiStore.backNivOAfterAddPhidget();
    }

    return (
        <>
            <div>
                <TitreConfigurerPhidget />
                <WidgetTitre titre={"Planning d'actions"} />
            </div>
            <div className={styles.listeChampsFormulaire}>
                {planningExistant ? (
                    <div className={styles.planningExistantMsg}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                             stroke="#00B0FF" strokeWidth="2" strokeLinecap="round">
                            <circle cx="12" cy="12" r="10"/>
                            <line x1="12" y1="8" x2="12" y2="12"/>
                            <line x1="12" y1="16" x2="12.01" y2="16"/>
                        </svg>
                        <span>
                            Un planning d'actions est déjà configuré pour cet écran.
                            Un seul planning par écran est autorisé.
                        </span>
                    </div>
                ) : (
                    <div className={styles.form_add_widget}>
                        <label htmlFor="pa-nom">Nom du planning</label>
                        <input
                            id="pa-nom"
                            className={"form-control " + styles.input_add_widget}
                            type="text"
                            placeholder="Ex : Plan d'actions atelier A"
                            value={plaNom}
                            onChange={(e) => setPlaNom(e.target.value)}
                            onKeyDown={(e) => { if (e.key === "Enter") handleCreer(); }}
                            autoFocus
                        />
                        {plaNom.trim() === "" && (
                            <p className="text-danger alerte" style={{ fontSize: "0.8rem", marginTop: "4px" }}>
                                Veuillez saisir un nom pour le planning
                            </p>
                        )}
                    </div>
                )}
                {/* Boutons d'action */}
                <div className={styles.WidgetButtonContent}>
                    {modeModification ? (
                        <BoutonSupprimerWidget
                            idWidget={idWidget}
                            widgetName={"Planning d'actions"}
                            typeWidget={"WidgetPlanningActions"}
                        />
                    ) : (
                        !planningExistant && (
                            <BtnPrimary onClick={handleCreer} disabled={!peutCreer}>
                                Créer le planning
                            </BtnPrimary>
                        )
                    )}
                </div>
            </div>
        </>
    );
};
export default CreatePlanningActions;
